<template>
	<v-responsive max-width="1440" width="100%" height="100%" class="mx-auto overflow-visible">
        <v-layout align-end class="mt-8">
            <span class="headline text-start">연도별 수상기업 관리</span>
            <v-spacer/>
            <v-btn color="secondary" rounded @click="showSearch = !showSearch"> <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터 </v-btn>
        </v-layout>

		<v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto mt-2">
                <v-card-title>
                    <span class="subtitle-2 font-weight-bold">검색필터</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" hide-details label="검색조건" @input="filter.searchValue = null"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="filter.searchValue" hide-details clearable label="검색어" :disabled="!filter.searchKey" @keydown.enter="search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search(true)"> <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색 </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

		<v-data-table :headers="awardsHeaders" :items="awards" disable-sort disable-pagination hide-default-footer :items-per-page="-1" class="elevation-1 mt-2">
			<template v-slot:[`item.no`]="{ item }">
				{{ (page - 1) * limit + (+awards.indexOf(item) + 1) }}
			</template>
			<template v-slot:[`item.link`]="{ item }">
				<v-icon>mdi-link</v-icon>
			</template>
			<template v-slot:[`item.createdAt`]="{ item }">
				{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
			</template>
			<template v-slot:[`item.actions`]="{ item }">
                <i class="mdi mdi-pencil v-icon v-icon--link grey--text text--darken-3 mx-1" style="font-size: 16px" @click="edit(item)" />
                <i class="mdi mdi-delete v-icon v-icon--link grey--text text--darken-3 mx-1" style="font-size: 16px" @click="remove(item)" />
            </template>
		</v-data-table>

		<v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="search(true)"></v-pagination>

		<v-img src="/images/console/main.png" width="450"></v-img>

		<v-btn fab fixed right bottom color="accent" @click="create()">
			<v-icon>mdi-pencil</v-icon>
		</v-btn>

	</v-responsive>
</template>

<script>
import api from '@/api'
export default {
	data() {
		return {
			filter: {
				searchKey: null,
				searchValue: null
			},

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

			showSearch: true,

			searchKeys: [
				{ text: ":: 전체 ::", value: null},
				{ text: "회사명", value: "name"}
			],

			awardsHeaders: [
				{ text: "순서", value: "sequence", align: "center", width: 180 },
				{ text: "회사명", value: "name", align: "center", width: 180 },
				// { text: "이미지", value: "image", align: "center", width: 180 },
				// { text: "링크", value: "link", align: "center", width: 180 },
				{ text: "작성일", value: "createdAt", align: "center", width: 180 },
				{ text: "Actions", value: "actions", width: 120, align: "center" },
			],
			awards: [],
			summary: null,
		}
	},
	async mounted() {
		await this.init();
	},
	methods: {
		async init() {
			await this.search();
		},
		async search() {
			let { summary, awards } = await api.console.main.award.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
			})
			this.awards = awards;
			this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
		},

		create() {
			this.$router.push("/console/main/award/create")
		},
		edit(item) {
			this.$router.push(`/console/main/award/${item?._id}`)
		}, 
		async remove(item) {
			if(confirm("삭제하시겠습니까?")){
				await api.console.main.award.delete({ _id: item._id })

				alert("삭제되었습니다.")
				await this.search()
			}
		}
	}
}
</script>